import { useState, useEffect } from 'react'
import { Box, Typography, Button, IconButton, Grid, AccordionDetails, AccordionSummary, Accordion, useMediaQuery, useTheme } from "@mui/material";
import { settingsMenuData } from '../../Data';
import { ReactComponent as DownArrow } from '../../img/DownArrow.svg';
import UserProfileInfo from '../../components/UserAccount/UserProfileInfo';
import UserPersonalInfo from '../../components/UserAccount/UserPersonalInfo';
import BankStatements from '../../components/BankInformation/BankStatements';
import QRcode from '../../components/Wallet/QRcode';
import WalletAddress from '../../components/Wallet/WalletAddress';
import WalletNeedHelp from '../../components/Wallet/NeedHelp';
import UserVerification from './userVerification';
import { useAuth0 } from '@auth0/auth0-react';
import EditProfile from '../../components/UserAccount/EditProfile';
import { useSearchParams, useLocation  } from 'react-router-dom';
import NotificationTopics from './NotificationTopics';
import MainLayout from '../../components/MainLayout';
import DeviceTokens from './DeviceTokens';
import { colors } from '../../Theme/tokens';



const AccordianStyle = { boxShadow: 'none', margin: '0px !important', }
const AccordianSummaryStyle = {
  '.MuiAccordionSummary-content': {
    margin: ' 0px !important',
  },
  padding: '0px',
  ' .MuiAccordionSummary-expandIconWrapper': {
    position: 'absolute',
    top: '-40px',
    right: 0,
  },
}

const expandIconStyle = {
  width: '45px',
  height: '45px',
  backgroundColor: 'white !important',
  padding: '0px',
  boxShadow: "0 2px 1px -1px rgba(0,0,0,0.2) !important",
  display: { xs: 'block', md: 'none' }
}

export default function Settings({docusignStatus}) {
  const location = useLocation();
  const [searchParams] = useSearchParams ()
  const eventParam = searchParams.get('event');
  const theme = useTheme()
  const { logout } = useAuth0();
  const [isSelected, setIsSelected] = useState({user_profile: true, user_account: false, bank_information: false, wallets: false, deposits: false, User_Verification: false, notification_topics: false, subscription_plan: false, default_currency: false, docusign:false, help: false, logout: false, device_tokens: false })
  const [expand, setExpand] = useState(true)
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [isEdit, setIsEdit] = useState(false)
  const [isSaveClicked, setIsSaveClicked] = useState(false)

  useEffect(() => {
    setExpand(true)
    if( localStorage.getItem('docusignStatus') || eventParam) {
      const selectedObject = {user_profile: false, user_account: false, bank_information: false, wallets: false, deposits: false, notification_topics: false, kyc_docusign: false, docusign:false, subscription_plan: false, default_currency: false, help: false, logout: false, device_tokens: false }
      setIsSelected({ ...selectedObject, ['User_Verification']: true })
    }
  }, [isSmallScreen,eventParam])


  useEffect(() => {
    if (location.search) {
      const newUrl = window.location.origin + location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, [location]);


  const handleMenuClick = (key) => {
    isSmallScreen && setExpand(false)
    const selectedObject = {user_profile: false, user_account: false, bank_information: false, wallets: false, deposits: false, kyc_docusign: false, notification_topics: false, docusign:false, subscription_plan: false, default_currency: false, help: false, logout: false, device_tokens: false }
    setIsSelected({ ...selectedObject, [key]: true })
    if (key == "logout") {
      localStorage.removeItem('userData')
      localStorage.removeItem('token')
      localStorage.removeItem('applicantId')
      localStorage.removeItem('userId')
      logout();
    }
  }

  return (
    <MainLayout>
      <Grid container xs={12} p={2} backgroundColor='white' borderRadius="18px" sx={{boxShadow: `0px 1px 5px 0px ${colors.border.card}`}}>
        <Grid xs={12} md={3}>
          <Box sx={{ padding: '30px 10px', height: '100%', backgroundColor: colors.background.paper, borderRadius: '18px', boxShadow: `0px 1px 5px 0px ${colors.border.card}` }}>
            <Accordion key={1} sx={AccordianStyle} defaultExpanded={true} expanded={expand}>
              <AccordionSummary sx={{ ...AccordianSummaryStyle, minHeight: '0px !important' }}
                expandIcon={
                  <IconButton onClick={() => setExpand(!expand)}
                    sx={expandIconStyle}><DownArrow />
                  </IconButton>}
              >
                <Box sx={{ backgroundColor: colors.background.paper, display: { md: 'none' }, width: '100%', padding: '0px 10px', }}>
                  <Typography variant='h2' sx={{ mb: '0px', }}>Settings </Typography>
                </Box>
              </AccordionSummary >
              <AccordionDetails sx={{ padding: '0px' }}>
                <Box pt={{ xs: 4, md: 0 }} sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: '25px', backgroundColor: colors.background.paper, alignItems:"flex-start" }}>
                  {settingsMenuData?.map((item,index) => (
                    <Button disabled={(index == 1 || index == 3 ) ? true : false} style={{cursor: (index == 1 || index == 3) ? "not-allowed" : 'pointer',}} variant='text' sx={{ textTransform: 'none', color: isSelected[item.key] == true ? colors.secondary.main : colors.neutral.outlinedText,}} onClick={() =>  (index == 1 || index == 3) ? null : handleMenuClick(item.key) }>
                      <Typography variant='h4' sx={{fontWeight:"600", textAlign:"left" }}> {item.name}</Typography>
                    </Button>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Grid>
        <Grid xs={12} md={9} pl={{ xs: 0, md: 2.3 }} pt={{ xs: 2, md: 0 }} >
          <Box>
          <UserProfileInfo setIsSaveClicked={setIsSaveClicked} isSaveClicked={isSaveClicked} setIsEdit={setIsEdit} isEdit={isEdit} isUserProfile={isSelected?.user_profile ? true : false}/>
            {isSelected.user_profile == true && <>
              {isEdit ? <EditProfile isSaveClicked={isSaveClicked} setIsSaveClicked={setIsSaveClicked} setIsEdit={setIsEdit} /> : <UserPersonalInfo />}
              </>}
            {isSelected.user_account == true && <>
              <BankStatements /></>}
            {isSelected.wallets == true && <><QRcode />
              <WalletAddress />
              <WalletNeedHelp />
            </>}
            {(isSelected.User_Verification == true || localStorage.getItem('docusignStatus')) && <>
              <UserVerification docusignStatus={docusignStatus}/>
            </>}
            {isSelected.notification_topics == true && <>
              <NotificationTopics />
            </>}
            {isSelected.device_tokens == true && <>
              <DeviceTokens />
            </>}
          </Box>
        </Grid>
      </Grid >
    </MainLayout >
  )
}
